import { useEffect, useRef } from "react";
import Button from "../../../components/button";
import SectionTitle from "../../../components/section-title";
import Parallax from "parallax-js";

const CustomAboutContainer = () => {
    const sceneEl = useRef(null);

    useEffect(() => {
        const parallaxInstance = new Parallax(sceneEl.current, {
            relativeInput: true,
        });

        parallaxInstance.enable();

        return () => parallaxInstance.disable();
    }, []);
    return (
        <div className="about-us position-relative custom-about">
            <img
                className="custom"
                src={`${process.env.PUBLIC_URL}/images/about/shape.png`}
                alt="bg-shape"
            />
            <div className="container">
                <div className="row mb-n7">
                    <div className="col-xl-5 col-lg-6 mb-7">
                        <div className="about-content">
                            <SectionTitle
                                classOption="title-section"
                                subTitle="Become a Partner"
                                title="Partnership
                                <span class='text-primary'>
                                    we all value
                                </span>
                                <br className='d-none d-xl-block' />
                                "
                            />
                            
                            <p className="mb-5">
                            We are constantly looking out for partner/publisher in terms of both Providing and purchasing traffic. We make sure to drive the best traffic using our advance programmatic tech.
                            </p>
                            <p className="high-light mb-8">
                            We also provide job listing relevant to your site and get you paid for authentic traffic.

                            </p>
                            {/* <Button
                                classOption="btn btn-lg btn-dark btn-hover-dark"
                                text="Learn more"
                                path="/about"
                            /> */}
                        </div>
                    </div>
                    <div className="col-xl-6 order-first order-lg-start col-lg-6 mb-7 offser">
                        <div
                            className="about-photo scene text-center text-lg-left"
                            id="scene"
                            ref={sceneEl}
                        >
                            <div data-depth="0.2">
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/about/new.png`}
                                    alt="about"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    );
};

export default CustomAboutContainer;
